import axiosInstance from '@api/axios.ts';
import { urls } from '@api/urls.ts';
import {
  DetailDepositionSummaryTemplate,
  GenerateDepositionSummaryRequest,
} from '@app/types/deposition-summary-template';
import { DuplicateDocumentTemplateFormFields } from '@features/admin-multi-document-agent/utils/demand-letter/duplicate-template-validator';

export const updateDepositionSummaryTemplate = async (
  id: number,
  data: any
): Promise<DetailDepositionSummaryTemplate> => {
  const response = await axiosInstance.patch(
    urls.depositionSummaryTemplate.byId(id),
    data
  );

  return response.data;
};

export const generateDepositionSummaryTemplate = async (
  id: number,
  data: GenerateDepositionSummaryRequest
): Promise<DetailDepositionSummaryTemplate> => {
  const response = await axiosInstance.post(
    urls.depositionSummaryTemplate.generate(id),
    data
  );

  return response.data;
};

export const deleteDepositionSummaryTemplate = async (id: number) => {
  const response = await axiosInstance.delete(
    urls.depositionSummaryTemplate.byId(id)
  );

  return response.data;
};

export const duplicateDepositionSummaryTemplate = async (
  id: number,
  data: DuplicateDocumentTemplateFormFields
): Promise<DetailDepositionSummaryTemplate> => {
  const response = await axiosInstance.post(
    urls.depositionSummaryTemplate.duplicate(id),
    data
  );

  return response.data;
};

export const updateDepositionSummaryTemplateOrder = async (
  id: number,
  direction: 'up' | 'down'
): Promise<DetailDepositionSummaryTemplate> => {
  const response = await axiosInstance.patch(
    urls.depositionSummaryTemplate.updateOrder(id),
    { direction }
  );

  return response.data;
};
